var _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 600,
    viewBox: "0 0 300 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#2a2a2a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 280)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "none",
    stroke: "#555",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "none",
    stroke: "#888",
    strokeWidth: 4,
    strokeDasharray: "39 118",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: 0,
    to: 360,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 340,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#666",
    textAnchor: "middle"
  }, "Loading...")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingMobile);
export default __webpack_public_path__ + "static/media/loading-mobile.f3d80de43de61ab4e9465625f7279318.svg";
export { ForwardRef as ReactComponent };